var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.versions),function(version,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":"10","offset-md":"1"}},[_c('roadmap-version',{attrs:{"version":version}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }